import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=d3596ad4&scoped=true&"
import script from "./copy.vue?vue&type=script&lang=js&"
export * from "./copy.vue?vue&type=script&lang=js&"
import style0 from "./copy.vue?vue&type=style&index=0&id=d3596ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3596ad4",
  null
  
)

export default component.exports